import { changePasswordValidation } from '@/utils/valitation/auth';
import { Form, Formik } from 'formik';
import { useState } from 'react';

import FormField from '../FormField';
import EyeIcon from '@/components/icons/EyeIcon';
import Eyelock from '@/components/icons/Eyelock';
import toast from 'react-hot-toast';
import { resetNewPassword } from '@/services/auth';
import { getCookie } from 'cookies-next';

const ChangePassword = ({ t, setAuth, forgetData }) => {
  const intialValues = {
    password: '',
    confirmPassword: '',
  };
  const handshake = getCookie('handshake');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const handleLogin = async (values) => {
    const res = await resetNewPassword({
      handshake,
      email: forgetData?.email,
      newPassword: values.password,
      confirmPassword: values.confirmPassword,
      resetToken: forgetData?.otp,
    });

    if (!res?.data || res?.error?.error?.message) {
      setAuth('Otp');
      toast.error(t(res?.error?.error?.message.replaceAll('.', '')));
    } else {
      toast.success(t('Password changed successfully'));
      setAuth('Change Password Success');
    }
  };
  return (
    <section className='mt-3 sm:mt-5'>
      <Formik
        onSubmit={handleLogin}
        initialValues={intialValues}
        validationSchema={changePasswordValidation(t)}
      >
        {({ errors, touched, isSubmitting }) => (
          <Form className='mt-3 grid grid-cols-2 gap-3'>
            <div className='col-span-full'>
              <FormField
                inputClassName='w-full rounded-md border p-1.5 max-sm:placeholder:text-sm max-sm:text-sm sm:p-2 outline-none'
                placeholder={t('Password')}
                name='password'
                type={showPassword ? 'text' : 'password'}
                icon={
                  !showPassword ? (
                    <EyeIcon
                      onClick={() => setShowPassword(true)}
                      className='absolute end-2 top-1/2 -translate-y-1/2 cursor-pointer text-secondary'
                    />
                  ) : (
                    <Eyelock
                      onClick={() => setShowPassword(false)}
                      className='absolute end-2 top-1/2 size-[18px] -translate-y-1/2 cursor-pointer text-secondary'
                    />
                  )
                }
                errorClassName='text-red-600 text-sm mt-1 max-sm:text-xs'
                t={t}
                errors={errors}
                touched={touched}
              />
            </div>
            <div className='col-span-full'>
              <FormField
                inputClassName='w-full rounded-md border p-1.5 max-sm:placeholder:text-sm max-sm:text-sm sm:p-2 outline-none'
                placeholder={t('Confirm Password')}
                name='confirmPassword'
                type={showConfirm ? 'text' : 'password'}
                icon={
                  !showConfirm ? (
                    <EyeIcon
                      onClick={() => setShowConfirm(true)}
                      className='absolute end-2 top-1/2 -translate-y-1/2 cursor-pointer text-secondary'
                    />
                  ) : (
                    <Eyelock
                      onClick={() => setShowConfirm(false)}
                      className='absolute end-2 top-1/2 size-[18px] -translate-y-1/2 cursor-pointer text-secondary'
                    />
                  )
                }
                errorClassName='text-red-600 text-sm mt-1 max-sm:text-xs'
                t={t}
                errors={errors}
                touched={touched}
              />
            </div>
            <button
              disabled={isSubmitting}
              className='col-span-full flex w-full items-center justify-center gap-4 rounded-md bg-primary p-2 font-semibold text-white hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-75 max-sm:text-sm'
            >
              {isSubmitting && (
                <span className='size-4 animate-spin rounded-full border-2 border-r border-t border-white' />
              )}
              {t('Change Password')}
            </button>
          </Form>
        )}
      </Formik>
    </section>
  );
};

export default ChangePassword;
